import React from 'react';
import { List, Space, Typography } from 'antd';
import type { StopOperationalContext } from '../routes/execution/operationalContextFacade';
import {
  formatCargoLinesList,
  formatOperationalDateTime
} from '../routes/execution/operationalContextFacade';

const { Text } = Typography;

type Props = {
  context: StopOperationalContext;
  operationType?: 'loading' | 'unloading';
  showCargoDetail?: boolean;
  compact?: boolean;
};

export const OperationalContextBlock: React.FC<Props> = ({
  context,
  operationType = 'loading',
  showCargoDetail = true,
  compact = false
}) => {
  const doneLabel = operationType === 'loading' ? 'Загружено:' : 'Выгружено:';

  return (
    <Space direction="vertical" size={compact ? 4 : 8} style={{ width: '100%' }}>
      {context.applicationLabel ? (
        <Text style={{ fontSize: compact ? 12 : 13 }}>{context.applicationLabel}</Text>
      ) : null}
      {context.clientName ? (
        <Text type="secondary" style={{ fontSize: 12 }}>
          Клиент: {context.clientName}
        </Text>
      ) : null}
      {context.consigneeName ? (
        <Text type="secondary" style={{ fontSize: 12 }}>
          Грузополучатель: {context.consigneeName}
        </Text>
      ) : null}
      {context.warehouseName ? (
        <Text type="secondary" style={{ fontSize: 12 }}>
          Склад: {context.warehouseName}
        </Text>
      ) : null}

      {showCargoDetail && context.cargoLines.length > 0 ? (
        <div>
          <Text strong style={{ fontSize: 12 }}>
            Грузы:
          </Text>
          <List
            size="small"
            dataSource={context.cargoLines}
            renderItem={(line) => (
              <List.Item style={{ padding: '2px 0', border: 'none' }}>
                <Text style={{ fontSize: 12 }}>{line.name}</Text>
              </List.Item>
            )}
          />
        </div>
      ) : null}

      {context.totalPlaces > 0 ? (
        <Text style={{ fontSize: 12 }}>
          Количество: {context.totalPlaces} мест
          {context.totalWeightKg > 0 ? ` · ${context.totalWeightKg} кг` : ''}
        </Text>
      ) : null}

      <Text style={{ fontSize: 12 }}>
        План: {formatOperationalDateTime(context.plannedAt)}
      </Text>
      <Text style={{ fontSize: 12 }}>
        Факт: {formatOperationalDateTime(context.actualAt)}
      </Text>

      {context.loadedLines.length > 0 ? (
        <div>
          <Text strong style={{ fontSize: 12 }}>
            {doneLabel}
          </Text>
          {formatCargoLinesList(context.loadedLines).map((line) => (
            <Text key={line} style={{ display: 'block', fontSize: 12 }}>
              · {line}
            </Text>
          ))}
        </div>
      ) : null}

      {context.remainingLines.length > 0 ? (
        <div>
          <Text strong style={{ fontSize: 12 }}>
            Осталось:
          </Text>
          {formatCargoLinesList(context.remainingLines).map((line) => (
            <Text key={line} style={{ display: 'block', fontSize: 12 }}>
              · {line}
            </Text>
          ))}
        </div>
      ) : null}
    </Space>
  );
};

export default OperationalContextBlock;
